/* eslint-disable no-undef */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReadMoreAccordion from '../../SharedComponents/ReadMoreAccordion/ReadMoreAccordion';
import './Accordion.sass';

class AccordionItem extends Component {
  render () {
    const { title, content, number } = this.props;

    return (
      <div className="accordion-item">
        <h4>
          <span>
            {number}
.
          </span>
          {' '}
          {title}
        </h4>
        <div role="presentation">
          <ReadMoreAccordion
            lines={1}
            more={I18n.t('list_view.read_more')}
            less={I18n.t('list_view.read_less')}
            readMore
            width={647}
          >
            {content}
          </ReadMoreAccordion>
        </div>
      </div>
    );
  }
}

AccordionItem.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  number: PropTypes.number,
};

AccordionItem.defaultProps = {
  title: '',
  content: '',
  number: 0,
};

export default AccordionItem;
